@if (this.primaryGridAction) {
    <button
        type="button"
        title="menu"
        mat-flat-button
        color="primary"
        class="!w-full !h-8 !px-5 !border-primary-700"
        [disabled]="this.primaryGridAction.disabled"
        (click)="this.primaryGridAction.action()"
    >
        <span class="text-sm tracking-normal text-nowrap">{{
            this.primaryGridAction.title
        }}</span>
    </button>
}
